import { connect } from "react-redux";

import Dashboard from "../../../mui/Dashboard";
import { AninharView, menuRotas, rotas } from "../../../services/router";
import { db } from "../../../services/db";
import { memo, useEffect, useState } from "react";
import { PageDegrade } from "../../../mui/PageDegrade";
import { Box, Button, CircularProgress, CssBaseline, LinearProgress, Skeleton, Stack, Typography, useColorScheme } from "@mui/material";

import Alerts from "../../../components/alerts/Alerts";
import { Login, PersonPinSharp, Preview } from "@mui/icons-material";
import { SplashScreen } from "./splash";
import { mapDispatchToStatusAppProps, mapStateToStatusAppProps, StatusAppViewProps } from "../root.controller";
import PainelView from "../../painel/painel"
import AppTheme from "../../../mui/shared-theme/AppTheme";
import { Paciente } from "../../paciente/paciente.model";
import { handleReadPacientesByAtendimento, handleSetFiltroPaciente } from "../../paciente/view/paciente.select";
import { atendimentoController } from "../../atendimento/atendimento.controller";


const MAIN_SISTEMA = process.env.PARCEL_MAIN_SISTEMA;


function Rootview(props: StatusAppViewProps) {
    const { start } = props.statusAppState
    const { mode, setMode } = useColorScheme();
    
    useEffect(()=>{
        setMode("dark");
        startSync()
        return cancelSync;        
    },[])

    const cancelSync = () => {
        console.log("chamou cancelar sync");
        db.sync?.cancel();
    }    
    const startSync = async () => {
        try {

            db.startSync({
                dataAmericana: new Date().toISOString(),
                functionCallbackChange: (prms) => {
                    console.log("sync change", prms)
                    let rows = prms.change.docs.filter((doc: any) => doc.type === "paciente") as any;
                    console.log("find",rows,atendimentoController)
                    if(rows.length > 0){
                        if(atendimentoController.state.sessaoStarted){
                            let find  = rows.find((row:Paciente)=>row.atendimento.medico._id === atendimentoController.state.row.medico._id)
                            if(find)
                                handleReadPacientesByAtendimento(atendimentoController.state.row)
                        }
                        handleSetFiltroPaciente(props.pacienteState.filtro)
                    }
                },
                handleCallbackPause: (prmState) => {
                    console.log("sync pause", prmState)

                },
                handleErrorCallback: (error) => {
                    console.log("sync error", error)
                },
                handleFirstReplicateDone: (info) => {
                    console.log("sync handleFirstReplicateDone", info)
                }
            })
        } catch (error) {
            console.log("Falha ao iniciar sicronizacao")
        }
    }

    
    if (start) {
        if (MAIN_SISTEMA === "gestor") {
            return (
                <Dashboard
                    menuProps={{
                        listItens: menuRotas,
                        funcLogado: { nome: "Administrador" },
                        logout: () => { },
                        versao: props.statusAppState.versao

                    }}
                    propsApp={props}
                >
                    <AninharView />
                </Dashboard>
            )

        } else {
            return (
                <AppTheme >

                    <CssBaseline enableColorScheme />
                    <Box sx={{ display: 'flex', flex: 1 }}>
                        <PainelView />
                    </Box>
                </AppTheme>
            )
        }
    }

    return (
        <PageDegrade>
            <CssBaseline />
            <SplashScreen loading={props.statusAppState.loading} msg={props.statusAppState.msg} />
        </PageDegrade>
    )
}

const RootViewMomoized = memo(Rootview,(prev,next)=>{
    return prev.statusAppState.start === next.statusAppState.start &&
    prev.statusAppState.loading === next.statusAppState.loading &&
    prev.statusAppState.msg === next.statusAppState.msg
})

export default connect(mapStateToStatusAppProps, mapDispatchToStatusAppProps)(Rootview);